import React from "react";
import "./MixedPaymentStatusDisplay.css";

/**
 * RTL status line — single combined text or dual badges for mixed credit + bank transfer.
 * @param {{ displayStatus?: string|null, badges?: Array<{ label: string, tone?: string }>|null, variant?: 'inline'|'badges'|'auto' }} props
 */
export default function MixedPaymentStatusDisplay({
  displayStatus = null,
  badges = null,
  variant = "auto",
  className = "",
}) {
  const list = Array.isArray(badges) ? badges.filter((b) => b?.label) : [];
  const useBadges =
    variant === "badges" || (variant === "auto" && list.length > 1);

  if (useBadges && list.length > 0) {
    return (
      <span
        className={`mixed-payment-status mixed-payment-status--badges ${className}`.trim()}
        dir="rtl"
      >
        {list.map((badge, i) => (
          <span
            key={`${badge.label}-${i}`}
            className={`mixed-payment-status__badge mixed-payment-status__badge--${badge.tone || "muted"}`}
          >
            {badge.label}
          </span>
        ))}
      </span>
    );
  }

  const text =
    (displayStatus && String(displayStatus).trim()) ||
    (list.length === 1 ? list[0].label : null);
  if (!text) return null;

  return (
    <span className={`mixed-payment-status mixed-payment-status--inline ${className}`.trim()} dir="rtl">
      {text}
    </span>
  );
}
